import { Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { WorkflowStepper } from "./WorkflowStepper";
import { useSelector } from "react-redux";
import { IAllStates } from "../../../store/rootReducer";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { PreviewProductModal } from "../../products/components/PreviewProductModal";
import { useEffect, useState } from "react";
import { ProductsService } from "../../products/service";
import { ErrorToast } from "../../../shared/toasters/toasters";

export const WorkflowStep9Preview = () => {
  const { id, productId } = useParams();
  const workflowData = useSelector((state: IAllStates) => state.workflow);
  const { t } = useTranslation();
  const [productBaseData, setProductBaseData] = useState();

  useEffect(() => {
    productId &&
      ProductsService.getProductById(+productId, "BASE_DATA")
        .then((response: any) => {
          setProductBaseData(response);
        })
        .catch((error) => ErrorToast(error));
  }, [productId]);
  return (
    <Card>
      <Helmet>
        <title>
          {workflowData?.name ?? "-"} {t("workflow.PREVIEW")}
        </title>
      </Helmet>
      <Card.Body>
        <WorkflowStepper id={id} step={"PREVIEW"} />
        <div className="row">
          {(productBaseData as any)?.id && (
            <PreviewProductModal
              productBaseData={productBaseData}
              setProductBaseData={setProductBaseData}
              isWorkflow={true}
            />
          )}
        </div>
      </Card.Body>
    </Card>
  );
};
